import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PlantListCompanyActions from './plant-list-company.actions';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectPlantListByKey } from './plant-list-company.selectors';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { PlantListCompanyStoreService } from './plant-list-company.service';

@Injectable()
export class PlantListCompanyEffects {
  constructor(
    private actions$: Actions,
    private plantListService: PlantListCompanyStoreService,
    private alert: ArkikAlertService,
    private translation: TranslationService,
    private store: Store,
    private cookieService: CookieService,
  ) {}

  loadPlantListCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantListCompanyActions.loadPlantListCompany),
      switchMap(() => {
        const userGuid = this.cookieService.get(environment.UserGuid).toUpperCase();
        const companyGuid = this.cookieService.get(environment.CompanyGuid).toUpperCase();
        const key = `${userGuid}_${companyGuid}`;
        return this.store.select(selectPlantListByKey(userGuid, companyGuid)).pipe(
          take(1),
          switchMap((plants) => {
            if (plants) {
              // Ya existe, no llamamos a la API
              return of(PlantListCompanyActions.loadPlantListCompanySuccess({ key, plants }));
            }
            // No existe, llamamos a la API
            return this.plantListService.getPlantListWithCompany().pipe(
              map((response) => PlantListCompanyActions.loadPlantListCompanySuccess({ key, plants: response })),
              catchError((e) => {
                this.alert.error(e?.error?.message || this.translation.pt('views.globals.an-error-occurred'));
                return of(
                  PlantListCompanyActions.loadPlantListCompanyFailure({
                    error: e?.error?.message || this.translation.pt('views.globals.an-error-occurred'),
                    key,
                  }),
                );
              }),
            );
          }),
        );
      }),
    ),
  );

  refreshPlantListCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantListCompanyActions.refreshPlantListCompany),
      map(() => PlantListCompanyActions.resetPlantListCompany()),
    ),
  );
}
